module.exports = __webpack_public_path__ + "static/media/imagem19.fc8cd670.jpeg";